import { EyeOutlined } from '@ant-design/icons'
import { Button, Space } from 'antd'
import ButtonGroup from 'antd/es/button/button-group'
import { FC } from 'react'
import PreviewShipmentBlank from '../../../../components/buttons/preview-shipment-blank/preview-shipment-blank'
import PrintJob from '../../../../types/api/print-job'
import { hasSavedMaterialConsumptions } from '../../helpers/consumption-helpers'
import ConsumptionFormModal from '../consumption-form/consumption-form-modal'

interface ActionsCellProps {
    printJob: PrintJob
    onSuccess: () => void
}

const ActionsCell: FC<ActionsCellProps> = ({ printJob, onSuccess }) => {
    const shipment = printJob.shipment

    if (!shipment) return null

    return (
        <Space>
            <ButtonGroup>
                <PreviewShipmentBlank
                    shipment={shipment}
                    blankType="production"
                    blankPreviewFiles={shipment.blankPreviewFiles}
                >
                    <Button
                        title="Посмотреть бланк"
                        size="small"
                        icon={<EyeOutlined />}
                        color="magenta"
                        variant="solid"
                    />
                </PreviewShipmentBlank>
                {!hasSavedMaterialConsumptions(printJob) && (
                    <ConsumptionFormModal printJob={printJob} onSuccess={onSuccess} />
                )}
            </ButtonGroup>
        </Space>
    )
}

export default ActionsCell
